import React from 'react';
import {Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next';

const InfoBasic = ({basicInfo={}, record, actual}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={6} >
                    {t("messages.aml.nameOrBusinessName")}
                    <Input readOnly value={basicInfo.name ? basicInfo.name : record.nombre}/>
                </Col>
                <Col span={6}>
                    {t("messages.aml.documentType")}
                    <Input readOnly value={basicInfo.tipoDocumento ? basicInfo.tipoDocumento : t("messages.aml.rut")}/>
                </Col>
                <Col span={6}>
                    {t("messages.aml.identificationNumber")}
                    <Input readOnly value={basicInfo.nroDocumento ? basicInfo.nroDocumento : record.rut }/>
                </Col>
                <Col span={6}>
                    {t("messages.aml.personType")}
                    <Input readOnly value={record.type === 'Person' ? t("messages.aml.person"): t("messages.aml.company")} />
                </Col>
                {record.type === 'Person' &&
                <>
                    <Col span={6} >
                        {t("messages.aml.relationshipPurpose")}
                        <Input readOnly value={basicInfo.propositoRel} className={actual && basicInfo.propositoRel !== actual.propositoRel && "difference"} />
                    </Col>
                    <Col span={6}>
                        {t("messages.aml.nationality")}
                        <Input readOnly value={basicInfo.nationality} className={actual && basicInfo.nationality !== actual.nationality && "difference"} />
                    </Col>
                    <Col span={6}>
                        {t("messages.aml.residenceCountry")}
                        <Input readOnly value={basicInfo.residenciaPais} className={actual && basicInfo.residenciaPais !== actual.residenciaPais && "difference"} />
                    </Col>
                    <Col span={6}>
                        {t("messages.aml.occupationOrTrade")}
                        <Input readOnly value={basicInfo.oficio} className={actual && basicInfo.oficio !== actual.oficio && "difference"} />
                    </Col>
                </>
                }
                {record.type === 'Entity' &&
                <>
                    <Col span={6} >
                        {t("messages.aml.relationshipPurpose")}
                        <Input readOnly value={basicInfo.propositoRel} className={actual && basicInfo.propositoRel !== actual.propositoRel && "difference"} />
                    </Col>
                    <Col span={6}>
                        {t("messages.aml.societyType")}
                        <Input readOnly value={basicInfo.tipoSociedad} className={actual && basicInfo.tipoSociedad !== actual.tipoSociedad && "difference"} />
                    </Col>
                    {basicInfo.tipoEmpresa !== undefined &&
                        <Col span={6}>
                            {t("messages.aml.companyType")}
                            <Input readOnly value={basicInfo.tipoEmpresa} className={actual && basicInfo.tipoEmpresa !== actual.tipoEmpresa && "difference"} />
                        </Col>
                    }
                    {basicInfo.tamEmpresa !== undefined &&
                        <Col span={6}>
                            {t("messages.aml.companySize")}
                            <Input readOnly value={basicInfo.tamEmpresa} className={actual && basicInfo.tamEmpresa !== actual.tamEmpresa && "difference"} />
                        </Col>
                    }
                </>
                }
            </Row>
        </div>
    );
};

export default InfoBasic;